import React from 'react'
import { Loca as BaseLoca } from '@gameforge/loca/react'
// TODO: Adjust @gameforge/loca package to export this
import { Props } from '@gameforge/loca/react/components/Loca'

export const Loca = <T extends React.ElementType>(props: Props<T>) =>
  React.createElement(BaseLoca, { ...props, as: props.as || 'span' })
